<template>
  <section class="page-wrapper">
    <section class="login-screen">
      <!--Moving Poster-->
      <section class="posters-list">
        <section class="posters-list-container">
          <div v-for="index in 60" :key="index" class="poster-item">
            <div class="poster-image" :style="(posters[index]) ? `background-image:url(https://image.tmdb.org/t/p/w185_and_h278_face${posters[index]})` : ''"></div>
          </div>
        </section>
      </section>
      <!--Page Content-->
      <section class="login-content">
        <h1 class="login-logo">Movie Night</h1>
        <p class="login-slogan">What's the next movie I have to watch ?</p>
        <section class="login-container">
          <!-- Offline instruction -->
          <div v-show="!networkOnLine" class="login-instruction" data-test="offline-instruction">
            Please check your connection, login feature is not available offline.
          </div>
          <section class="forms-sections">
            <form v-if="showRegister" class="login-form" action="#" @submit.prevent="submit">
              <h2 class="form-title">Create a new account</h2>
              <div v-if="error" class="login-error">{{ error }}</div>
              <input id="register-email" v-model="form.registerEmail" type="email" name="email" placeholder="Your email address" value required />
              <input id="register-password" v-model="form.registerPassword" type="password" name="password" placeholder="Choose a password" required />
              <button type="submit">Register</button>
              <a @click.prevent="showRegister = !showRegister">Already have an account ? Log in.</a>
            </form>
            <form v-else class="login-form" action="#" @submit.prevent="login">
              <h2 class="form-title">Log in</h2>
              <div v-if="error" class="login-error">{{ error }}</div>
              <input id="login-email" v-model="form.loginEmail" type="email" name="email" placeholder="Your email address" value required />
              <input id="login-password" v-model="form.loginPassword" type="password" name="password" placeholder="Your password" required />
              <button type="submit">Login</button>
              <a @click.prevent="showRegister = !showRegister">Don't have an account yet ? Create one.</a>
            </form>
          </section>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { isNil } from 'lodash'
import firebase from 'firebase'

export default {
  data: () => ({
    posters: [],
    showRegister: false,
    form: {
      loginEmail: '',
      loginPassword: '',
      registerEmail: '',
      registerPassword: ''
    },
    error: null
  }),
  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('app', ['networkOnLine', 'appTitle'])
  },
  watch: {
    user: {
      handler(user) {
        if (!isNil(user)) {
          const redirectUrl = isNil(this.$route.query.redirectUrl)
            ? '/'
            : this.$route.query.redirectUrl
          this.$router.push(redirectUrl)
        }
      },
      immediate: true
    }
  },
  mounted() {
    for (let i = 1; i <= 3; i += 1) {
      const apiKey = '65b432ac1b471e81a72be5d85a0a57b2'
      // const apiKey = process.env.MOVIE_DATABASE_API
      const url = `https://api.themoviedb.org/3/movie/popular?api_key=${apiKey}&language=en-US&page=${i}`

      this.axios.get(url).then((response) => {
        let movieCounter = 0
        response.data.results.forEach((movie) => {
          const arrayIndex = ((i - 1) * 20) + movieCounter
          this.posters[arrayIndex] = movie.poster_path
          movieCounter += 1
          this.posters = this.posters.slice(0)
        })
      })
    }
  },
  methods: {
    submit() {
      this.setUser(undefined)

      firebase
        .auth()
        .createUserWithEmailAndPassword(this.form.registerEmail, this.form.registerPassword)
        .then(data => {
          data.user
            .updateProfile({
              collections: []
            })
        })
        .catch(err => {
          this.error = err.message
          this.setUser(null)
        })
    },
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.loginEmail, this.form.loginPassword)
        .then(data => {
          console.log(data)
        })
        .catch(err => {
          this.error = err.message;
        });
    },
    ...mapMutations('authentication', ['setUser']),
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.page-wrapper {
  position: relative;
  padding: 0;

  .login-screen {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 30%;
      background: -moz-linear-gradient(top, rgba($dark, 0) 0%, rgba($dark, 1) 30%); /* FF3.6-15 */
      background: -webkit-linear-gradient(top, rgba($dark, 0) 0%,rgba($dark, 1) 30%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to bottom, rgba($dark, 0) 0%,rgba($dark, 1) 30%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$primaryColor', endColorstr='$primaryColor',GradientType=0 );
      z-index: 1;
    }

    .posters-list {
      position: absolute;
      top: 0;
      left: 0;
      width: 400%;
      transition: transform linear .2s;
      will-change: transform;
      animation-name: login-poster;
      animation-duration: 120s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;

      @keyframes login-poster {
        0% {
          transform: translateX(0);
        }
        47% {
          transform: translateX(-75%);
        }
        51% {
          transform: translateX(-75%);
        }
        97% {
          transform: translateX(0);
        }
      }

      .posters-list-container {
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        padding: 10px;

        .poster-item {
          width: calc((100% - 140px) / 15);
          margin-right: 10px;
          margin-bottom: 10px;

          &:nth-child(15n+15) {
            margin-right: 0;
          }

          .poster-image {
            width: 100%;
            padding-top: 150.25%; /* Keep movie poster ratio */
            border-radius: 5px;
            background-color: $shadeColor;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            transition: background-image ease-out .2s;
            will-change: background-image;
          }
        }
      }
    }

    .login-content {
      position: relative;
      width: 100%;
      z-index: 2;
      min-height: 52vh;
      display: flex;
      flex-direction: column;
      align-items: center;

      .login-logo {
        font-size: 44px;
        line-height: 44px;
        color: $light;
        margin: 0 0 10px;
        text-shadow: 0 0 40px $dark;
      }

      .login-slogan {
        margin: 10px 0 0;
      }

      .login-container {
        flex-grow: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px 40px;

        .login-instruction {
          width: 100%;
          text-align: center;
          margin: 0 0 40px;
        }

        .forms-sections {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;

          .login-form {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .form-title {
              font-size: 20px;
              margin: 0 0 20px;
            }

            .login-error {
              display: inline-block;
              font-size: 14px;
              color: $light;
              background-color: $danger-color;
              padding: 5px 10px;
              border-radius: 5px;
              margin: 0 0 20px;
            }

            input {
              width: 100%;
              appearance: none;
              background-color: $light;
              border: none;
              border-radius: 5px;
              font-size: 16px;
              line-height: 150%;
              padding: 10px 20px 10px 40px;
              margin-bottom: 10px;
              outline: none;
              color: $dark;

              &[type='email'] {
                background-image: url("data:image/svg+xml,%3Csvg width='21' height='21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.082 13.13a4.762 4.762 0 110-5.715V5.511h.953v7.619c0 1.05.945 1.65 2.05 1.35 1.33-.36 2.27-1.833 2.235-4.207a9.048 9.048 0 10-9.047 9.047c1.962 0 3.83-.626 5.374-1.768l.566.766a9.956 9.956 0 01-5.94 1.955c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 9.993c.04 2.775-1.157 4.65-2.94 5.134-1.673.454-3.25-.549-3.25-2.27zm-3.81.952a3.81 3.81 0 100-7.619 3.81 3.81 0 000 7.62z' fill='%23212121'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: left 10px center;
                background-size: auto 20px;
              }

              &[type='password'] {
                background-image: url("data:image/svg+xml,%3Csvg width='16' height='20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 10.992v7.016c0 .543.448.992.994.992h12.012a.994.994 0 00.994-.992v-7.016a.998.998 0 00-.994-.992H1.994a.994.994 0 00-.994.992zm9.828-8.82A3.987 3.987 0 008 1C5.794 1 4 2.793 4 5v4h8V5.001a3.99 3.99 0 00-1.172-2.83zM3 9V5a5 5 0 0110 .001V9h1.006C15.107 9 16 9.9 16 10.992v7.016c0 1.1-.895 1.992-1.994 1.992H1.994C.893 20 0 19.1 0 18.008v-7.016C0 9.892.895 9 1.994 9H3z' fill='%23212121'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: left 13px center;
                background-size: auto 20px;
              }
            }

            button[type="submit"] {
              display: inline-block;
              color: $light;
              background-color: $primaryColor;
              padding: 10px 20px;
              border-radius: 30px;
              border: none;
              outline: none;
              appearance: none;
              font-size: 18px;
              line-height: 150%;
              min-width: 200px;
              text-align: center;
              margin: 10px 0 30px;
            }

            a {
              display: inline-block;
              font-size: 14px;
              color: $light;
              background-color: $shadeColor;
              border-radius: 20px;
              padding: 5px 15px;
            }
          }
        }
      }
    }
  }
}
</style>
